// 🧠 DMR logic replicated in JS
function findDMR(teethList) {
  const dmrRanges = [
    { teeth: [36, 37, 46, 47], range: "18.43 - 32.02", value: "25.23" },
    { teeth: [16, 17, 26, 27], range: "25.23 - 38.81", value: "32.02" },
    { teeth: [14, 15, 24, 25], range: "32.02 - 45.60", value: "38.81" },
    { teeth: [35, 45], range: "38.81 - 52.39", value: "45.60" },
    { teeth: [11, 12, 21, 22], range: "45.60 - 59.18", value: "52.39" },
    { teeth: [13, 23], range: "52.39 - 65.98", value: "59.18" },
    { teeth: [34, 44], range: "59.18 - 72.77", value: "65.98" },
    { teeth: [31, 32, 41, 42], range: "65.98 - 79.56", value: "72.77" },
  ];

  let lastMatch = null;
  let continuousMatchFound = false;

  for (let i = 0; i < dmrRanges.length; i++) {
    const range = dmrRanges[i];
    const matchFound = teethList.some((tooth) =>
      range.teeth.includes(parseInt(tooth))
    );

    if (matchFound) {
      lastMatch = range;
      continuousMatchFound = true;
    } else if (continuousMatchFound) {
      return lastMatch;
    }
  }

  return continuousMatchFound ? lastMatch : null;
}

// 🧾 Main logic: assemble teeth + find DMR + format result
export function getDMRFromSubjectData(subject) {
  const decayTeeth = subject?.decayed_teeth || [];
  const restoredTeeth = subject?.restored_teeth || [];
  const missingTeeth = subject?.missing_teeth || [];
  const presentTeeth = subject?.present_teeth || [];

  const allTeeth = [
    ...decayTeeth,
    ...restoredTeeth,
    ...missingTeeth,
    ...presentTeeth,
  ];

  const dmrResult = findDMR(allTeeth);
  return dmrResult ? `${dmrResult.value} (${dmrResult.range})` : "-";
}
